<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'LICENSE_TYPES', url: '/admin/license-types' },
    { label: 'UPDATE_LICENSE_TYPE' }
  ]"
></breadcrumbs>

<page-header title="UPDATE_LICENSE_TYPE"></page-header>

<card>
  <form autocomplete="off" class="form" (submit)="onSubmit($event)">
    <div class="field is-narrow">
      <label class="label" translationEditableDirective="NAME">
        {{ 'NAME' | translate }}
      </label>
      <div class="control">
        <input
          class="input is-small"
          name="name"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['name'])"
          [ngClass]="{ 'is-danger': hasError('name') }"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('name')">
        {{ getError('name') }}
      </p>
    </div>

    <div class="field is-narrow">
      <label class="label" translationEditableDirective="CODE_PREFIX">
        {{ 'CODE_PREFIX' | translate }}
      </label>
      <div class="control">
        <input
          class="input is-small"
          name="codePrefix"
          type="text"
          (input)="handleFieldChange($event)"
          [value]="getField(['codePrefix'])"
          [ngClass]="{ 'is-danger': hasError('codePrefix') }"
          maxlength="5"
        />
      </div>
      <p class="help is-danger" *ngIf="hasError('codePrefix')">
        {{ getError('codePrefix') }}
      </p>
    </div>
  </form>
</card>

<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/license-types']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
    >
      {{ 'CANCEL' | translate }}
    </a>
  </div>
</div>
